import { StaticImageData, getImageProps } from "next/image";

import { ASSET_MEDIA_QUERY_BREAKPOINT } from "../Asset/constants";
import { isUnoptimizedImageEnv } from "../Asset/helpers";

type ArtDirectedImageProps = {
  mobileImage: StaticImageData;
  desktopImage: StaticImageData;
  description?: string;
  className?: string;
  breakpoint?: number;
  sizes?: string;
  onLoad?: () => void;
};

export default function ArtDirectedNextImage({
  mobileImage,
  desktopImage,
  description = "NVS Image",
  className,
  breakpoint = ASSET_MEDIA_QUERY_BREAKPOINT,
  sizes = "100vw",
  onLoad,
}: ArtDirectedImageProps) {
  // Mobile optimized source
  const {
    props: {
      // NOTE: These props were getting spread to the img tag, but they are not included in the typings :`(
      // Pulling them out to avoid the DOM validation errors.
      // @ts-expect-error
      blurWidth: _blurWidth,
      // @ts-expect-error
      blurHeight: _blurHeight,
      ...mobileProps
    },
  } = getImageProps({
    placeholder: "blur",
    unoptimized: isUnoptimizedImageEnv(),
    ...mobileImage,
    alt: description,
    sizes,
  });

  // Desktop optimized source
  const {
    props: { srcSet: desktop, src: desktopSrc },
  } = getImageProps({
    placeholder: "blur",
    unoptimized: isUnoptimizedImageEnv(),
    ...desktopImage,
    alt: description,
    sizes,
  });

  return (
    <picture onLoad={onLoad}>
      <source
        media={`(min-width: ${breakpoint}px)`}
        srcSet={desktop || desktopSrc}
      />
      <img className={className} {...mobileProps} alt={description} />
    </picture>
  );
}
